import { HFlow, Icon, Text } from 'bold-ui'
import { RequiredLabel } from 'components/form/final-form/RequiredLabel/RequiredLabel'
import React from 'react'

export const DiscussaoFormCustomLabelForConduta = () => {
  return (
    <HFlow hSpacing={0.5} alignItems='center'>
      <RequiredLabel label='Conduta' />
      <Icon icon='infoCircleOutline' size={1} fill='primary' />
      <Text color='primary' fontWeight='normal'>
        Só é possível selecionar uma conduta por registro.
      </Text>
    </HFlow>
  )
}
